<template>
  <div class="grid">
    <b-container fluid>
      <b-row>
        <b-col cols="12" sm="6" class="pagination d-none">
          <Pagination />
        </b-col>
        <b-col class="auction">Subasta {{ auction }}</b-col>
      </b-row>
      <b-row class="cars">
        <b-col cols="6" sm="4" md="3" v-for="car in cars" :key="car.id">
          <Car
            :id="car.id"
            :code="car.code"
            :brand="car.brand"
            :make="car.make"
            :model="car.model"
            :base="car.base"
            :pictures_slider="car.pictures_slider"
            :pictures_main="car.pictures_main"
            :pictures_normal="car.pictures_normal"
            :auction="auction"
            :bid="car.bid"
            :bidAffiliate="car.bidAffiliate"
            :bidStatus="car.bid_status"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Pagination from "./Pagination";
import Car from "./Car";

export default {
  name: "Grid",
  components: {
    Pagination,
    Car
  },
  props: {
    cars: {
      type: Array,
      default: function() {
        return [];
      }
    },
    auction: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.grid {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.auction {
  font-size: 1.3rem;
  color: $gray;
  font-weight: $font-weight-bold;
  text-transform: uppercase;
  text-align: right;
}

@media (max-width: prev-viewport-max-size("sm")) {
  .auction,
  .pagination {
    text-align: center;
    display: flex;
    justify-content: center;
  }
}
</style>
